import React, { PropTypes, Component } from 'react';
import networks from './networks';

class Mask extends Component {
  getStyle() {
    return {
      fill: this.props.color || networks.colorFor(this.props.networkKey)
    };
  }

  render() {
    return (
      <g {...this.props} className="social-svg-mask" style={this.getStyle()}>
        <path d={networks.maskFor(this.props.networkKey)} />
      </g>
    );
  }
}

Mask.propTypes = {
    color: React.PropTypes.string,
    networkKey: React.PropTypes.string.isRequired
};

export default Mask;



/** WEBPACK FOOTER **
 ** ./src/components/Icons/mask.js
 **/